<!--
  我的巡检任务：标准查询列表（根 div + avue-crud 事件链 + publicOption）。左侧「故障报修」依赖表格多选，选中行使用 mixin 的 selectionList。
-->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      :before-open="beforeOpen"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />
      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="handleFaultRepair" :loading="createTaskLoading">
          故障报修
        </el-button>
      </template>

      <template slot="workOrderId" slot-scope="{ row }">
        <el-button type="text" @click="handleView(row)" style="color: #409eff">
          {{ row.workOrderId }}
        </el-button>
      </template>

      <template slot="orderStatus" slot-scope="{ row }">
        <el-tag :type="getStatusButtonType(row.orderStatus)" size="small" effect="light">
          <i :class="getStatusIcon(row.orderStatus)"></i>
          {{ getStatusText(row.orderStatus) }}
        </el-tag>
      </template>

      <template slot="progress" slot-scope="{ row }">
        <div class="progress-container">
          <div class="progress-info">
            <span class="progress-text">
              <span class="completed-count">{{ row.completedPointCount }}</span>
              <span class="separator">/</span>
              <span class="total-count">{{ row.planPointCount }}</span>
            </span>
            <el-progress :percentage="
                getProgressPercentage(
                  row.completedPointCount,
                  row.planPointCount
                )
              " :color="
                getProgressColor(row.completedPointCount, row.planPointCount)
              " :show-text="false" :stroke-width="8" class="progress-bar" />
          </div>
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)" style="color: #409eff; margin-right: 8px">
          查看
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="故障报修" width="600px" :modal-append-to-body="false" :visible.sync="dialogFormVisible">
      <avue-form :option="optionForm" ref="form" v-model="formData">
      </avue-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入混入和工具函数
import crudMixins from "@/mixins/crud-mixins";
import { getUserInfo } from "@/api/system/user";
import { searchTimeConfig } from "@/basic-common/util/common";
import validator from "@/util/validate.js";

// 引入API方法
import {
  getList,
  add,
  update,
  remove,
  getDetail,
  distinctPage,
  insert,
} from "./api";

export default {
  name: "dispatched-my-inspection-task",
  // 混入crud基础功能
  mixins: [crudMixins],
  data () {
    return {
      // API配置
      apiConfig: { getList, add, update, remove, getDetail },
      // 默认查询参数
      defaultParams: {
        businessType: "inspection-task",
        status: 0,
      },
      // 加载状态
      createTaskLoading: false,
      // 故障报修对话框可见性
      dialogFormVisible: false,
      // 表单数据
      formData: {
        name: "",
      },
      // 用户信息（通过getUserInfo获取）
      userInfo: {},
      // 点位列表数据
      list: [],
      // 故障报修表单配置
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 150,
        span: 24,
        addText: "新增检查项",
        column: [
          {
            label: "选择点位",
            prop: "pointCode",
            dicData: [],
            dataType: "string",
            type: "select",
            props: {
              label: "pointLocation",
              value: "pointCode",
            },
            // 选择点位后填充相关信息
            change: async ({ value }) => {
              if (value) {
                this.setDetail(value)
              }
            },
            rules: [
              {
                required: true,
                message: "请选择点位",
                trigger: ["blur", "change"],
              },
            ],
          },
          {
            label: "报修人",
            prop: "reporterName",
            disabled: true,
          },
          {
            label: "手机号码",
            prop: "reporterPhone",
            overHidden: true,
            maxlength: 11,
            rules: [
              {
                required: true,
                validator: validator.notRequiredPhone,
                trigger: ["blur", "change"],
              },
            ],
          },
          {
            label: "故障地点",
            prop: "faultLocation",
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入故障地点",
                trigger: ["blur", "change"],
              },
            ],
          },
          {
            label: "故障描述",
            prop: "imageDesc",
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入故障描述",
                trigger: ["blur", "change"],
              },
            ],
          },
          {
            label: "优先级",
            prop: "priority",
            type: "select",
            props: { label: "dictValue", value: "dictKey" },
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=priority",
            rules: [{ required: true, message: "请选择优先级" }],
            slot: true,
            align: "center",
            span: 12,
            dataType: 'string',
          },
          {
            label: "图片",
            prop: "imagePath",
            type: "upload",
            multiple: true,
            drag: true,
            action: "/api/blade-resource/oss/endpoint/put-file-attach",
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            listType: "picture-card",
            tip: "支持多图上传, 最多上传4张",
            limit: 4,
            slot: true,
            span: 24,
            hide: true,
          },
        ],
      },
      // 表格配置
      option: {
        ...this.$store.state.publicOption,
        stripe: true,
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        searchBtn: true,
        searchResetBtn: true,
        searchMenuSpan: 6,
        selection: true,
        column: [
          {
            label: "工单编号",
            prop: "workOrderId",
            align: "center",
            overHidden: true,
            slot: true,
            search: true,
            searchPlaceholder: "请输入任务编号",
            searchSpan: 6,
          },
          {
            label: "计划名称",
            prop: "extPlanId",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请选择计划名称",
            searchSpan: 6,
            type: "select",
            dicUrl:
              "/api/produce/inspection-worko-rder/select/page/plan-info",
            props: { label: "extPlanName", value: "extPlanId" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "执行周期",
            prop: "executeCycle",
            align: "center",
            overHidden: true,
            formatter: (row) => {
              const cycleMap = {
                1: "每天",
                2: "每周",
                3: "每月",
                4: "自定义",
              };
              return cycleMap[row.executeCycle] || "未知";
            },
          },
          {
            label: "巡检路线",
            prop: "inspectionRouteCode",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请选择巡检路线",
            searchSpan: 6,
            type: "select",
            dicUrl:
              "/api/produce/inspection-worko-rder/select/page/router-info",
            props: { label: "inspectionRouteName", value: "inspectionRouteCode" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "计划时间",
            prop: "planTime",
            align: "center",
            overHidden: true,
            slot: true,
            formatter: (row) => {
              return row.cycleStartTime + '~' + row.cycleEndTime;
            },
          },
          {
            label: "执行时间",
            prop: "actualTime",
            align: "center",
            overHidden: true,
            slot: true,
            formatter: (row) => {
              return (row.actualStartTime || '--') + (row.actualEndTime ? '~' + row.actualEndTime : '');
            },
          },
          {
            label: "巡检人员",
            prop: "planPersonNames",
            align: "center",
            overHidden: true,
            searchPlaceholder: "请选择巡检人员",
            searchSpan: 6,
            type: "select",
            remote: true,
            filterable: true,
            dicUrl:
              "/api/produce/base-workorderuser/select/distinct/pycode?realName={{key}}",
            props: { label: "realName", value: "id" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "状态",
            prop: "orderStatus",
            align: "center",
            overHidden: true,
            slot: true,
            search: true,
            searchPlaceholder: "请选择任务状态",
            searchSpan: 6,
            type: "select",
            // dicData: [
            //   { label: "待执行", value: "0" },
            //   { label: "执行中", value: "1" },
            //   { label: "已完成", value: "2" },
            //   { label: "已超时", value: "3" },
            // ],
            dataType: 'string',
            dicData: this.$store.getters.commonDict['inspection_order_satus'],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: "创建时间",
            prop: "createTime",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            label: "进度",
            prop: "progress",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },
  // 组件挂载后初始化用户信息
  mounted () {
    this.handleWitch();
  },
  methods: {
    /**
     * 初始化表单数据，设置报修人信息
     */
    initFormat () {
      this.formData = {};
      if (this.userInfo && this.userInfo.name) {
        this.formData.reporterName = this.userInfo.name;
        this.formData.reporterId = this.userInfo.id;
        this.$set(this.formData, 'reporterPhone', this.userInfo.phone)
      }
    },

    /**
     * 获取用户信息并初始化表单
     */
    handleWitch () {
      getUserInfo()
        .then((res) => {
          if (res.data && res.data.data) {
            this.userInfo = res.data.data;
            this.initFormat();
          }
        })
        .catch((error) => {
          console.error('获取用户信息失败:', error);
        });
    },

    /**
     * 获取状态按钮类型
     * @param {string|number} status - 任务状态码
     * @returns {string} - ElementUI按钮类型
     */
    getStatusButtonType (status) {
      const typeMap = {
        0: "info",      // 待执行
        1: "primary",   // 执行中
        2: "success",   // 已完成
        3: "danger",    // 已超时
      };
      return typeMap[status] || "info";
    },

    /**
     * 获取状态图标
     * @param {string|number} status - 任务状态码
     * @returns {string} - ElementUI图标类名
     */
    getStatusIcon (status) {
      const iconMap = {
        0: "el-icon-time",    // 待执行
        1: "el-icon-user",    // 执行中
        2: "el-icon-check",   // 已完成
        3: "el-icon-warning", // 已超时
      };
      return iconMap[status] || "el-icon-time";
    },

    /**
     * 获取状态文本
     * @param {string|number} status - 任务状态码
     * @returns {string} - 状态显示文本
     */
    getStatusText (status) {
      const textMap = {
        0: "待执行",
        1: "执行中",
        2: "已完成",
        3: "已超时",
      };
      return textMap[status] || "未知";
    },

    /**
     * 计算进度百分比
     * @param {number} completed - 已完成数量
     * @param {number} total - 总数量
     * @returns {number} - 百分比值
     */
    getProgressPercentage (completed, total) {
      if (!total || total === 0) return 0;
      return Math.round((completed / total) * 100);
    },

    /**
     * 获取进度条颜色
     * @param {number} completed - 已完成数量
     * @param {number} total - 总数量
     * @returns {string} - 颜色值
     */
    getProgressColor (completed, total) {
      const percentage = this.getProgressPercentage(completed, total);
      if (percentage === 100) return "#67c23a"; // 完成 - 绿色
      if (percentage >= 50) return "#409eff";  // 进度过半 - 蓝色
      return "#e6a23c";                         // 进度较低 - 黄色
    },

    /**
     * 查看任务详情
     * @param {Object} row - 行数据
     */
    handleView (row) {
      if (!row || !row.id) {
        this.$message.warning("无效的任务数据");
        return;
      }
      this.$router.push(
        `/dispatched-personnel-track/InspectionTaskManage/detail/${row.id}`
      );
    },

    /**
     * 处理故障报修
     */
    handleFaultRepair () {
      const rows = this.selectionList || []
      if (!rows.length) {
        this.$message.warning("请选择一条工单进行操作！");
        return;
      }

      if (rows.length > 1) {
        this.$message.warning("只能选择一条工单进行操作！");
        return;
      }

      const selectedTask = rows[0];
      let params = {
        orderStatusStr: "1,2,3,4",
        status: "0",
        pasize: 9999,
        extId: selectedTask.workOrderId,
      };

      // 获取可选点位列表
      distinctPage(params)
        .then((res) => {
          this.initFormat();
          if (res.data && res.data.data && res.data.data.records && res.data.data.records.length) {
            this.list = res.data.data.records;
            this.optionForm.column[0].dicData = res.data.data.records;
            this.dialogFormVisible = true;
          } else {
            this.$message.info("当前工单无可报修的点位");
          }
        })
        .catch((error) => {
          console.error('获取点位列表失败:', error);
          this.$message.error("获取点位列表失败，请稍后重试");
        });
    },

    /**
     * 设置点位详情到表单
     * @param {string} pointCode - 点位编码
     */
    setDetail (pointCode) {
      if (!pointCode) return;

      const selectedPoint = this.list.find(res => res.pointCode === pointCode);
      if (selectedPoint) {
        this.formData = {
          ...this.formData,
          ...selectedPoint
        };
      }
    },

    /**
     * 提交故障报修表单
     */
    async submitForm () {
      this.$refs.form.validate((valid, done) => {
        if (valid) {
          // 准备提交参数，移除不必要的id字段
          const params = { ...this.formData };
          delete params.id;

          insert(params)
            .then(({ data }) => {
              if (data && data.success) {
                this.$message({
                  type: 'success',
                  message: data.msg || '故障报修成功',
                });
                // 重置表单并关闭对话框
                this.$refs.form.resetFields();
                this.dialogFormVisible = false;
                // 刷新表格数据
                this.refreshChange();
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg || '故障报修失败',
                });
              }
            })
            .catch((error) => {
              console.error('提交故障报修失败:', error);
              this.$message.error('故障报修提交失败，请稍后重试');
            })
            .finally(() => {
              done();
            });
        } else {
          done();
          this.$message.error("错误，请验证必填项并录入符合规则的数据");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;

  .progress-info {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    .progress-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      min-width: 50px;

      .completed-count {
        color: #67c23a;
        font-weight: 600;
      }

      .separator {
        color: #909399;
        margin: 0 2px;
      }

      .total-count {
        color: #909399;
      }
    }

    .progress-bar {
      flex: 1;
      min-width: 100px;
    }
  }
}

::v-deep .el-progress {
  .el-progress-bar__outer {
    background-color: #f5f7fa;
    border-radius: 10px;
  }

  .el-progress-bar__inner {
    border-radius: 10px;
    transition: width 0.6s ease;
  }
}
</style>
